module.exports = __webpack_public_path__ + "static/media/ecology.7a532d9b.svg";